import { useEffect, useRef, useState } from "react";
import Style from "../forms/utils/Forms.module.css"
const SearchableDropdown = ({
  options,
  label,
  id,
  selectedVal,
  handleChange,
  label2,
  disabled,
  placeholder,
  caculationData,
  setCaculationData
}) => {
  const [query, setQuery] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [focusedIndex, setFocusedIndex] = useState(-1);
  const optionRefs = useRef([]);
  const containerRef = useRef(null);

  const inputRef = useRef(null);

  useEffect(() => {
    document.addEventListener("click", toggle);
    return () => document.removeEventListener("click", toggle);
  }, []);

  const selectOption = (option) => {
    // setCaculationData({...caculationData,calculatedEmi: 0 })
    setQuery(() => "");
    handleChange(option[label]);
    setIsOpen((isOpen) => !isOpen);
  };

  function toggle(e) {
    setIsOpen(e && e.target === inputRef.current);
  }

  const getDisplayValue = () => {
    if (query) return query;
    if (selectedVal) return selectedVal;

    return "";
  };

  const filter = (options) => {
    return options.filter(
      (option) => option[label].toLowerCase().indexOf(query.toLowerCase()) > -1
    );
  };
  
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      if (!isOpen) {
        e.preventDefault();
        setIsOpen(true);
      } else if (focusedIndex >= 0 && focusedIndex < filter(options).length) {
        e.preventDefault();
        selectOption(filter(options)[focusedIndex]);
      }
    } else if (e.key === "ArrowDown") {
        e.preventDefault();
        setIsOpen(true);
        setFocusedIndex(prev => {
            const nextIndex = filter(options).length
                ? (prev + 1) % filter(options).length
                : 0;
          setTimeout(() => {
            optionRefs.current[nextIndex]?.scrollIntoView({ block: "nearest" });
          }, 0);
          return nextIndex;
        });
      } else if (e.key === "ArrowUp") {
          e.preventDefault();
          setIsOpen(true);
          setFocusedIndex(prev => {
                    const nextIndex = filter(options).length
                  ? (prev - 1 + filter(options).length) % filter(options).length
                  : 0;
            setTimeout(() => {
              optionRefs.current[nextIndex]?.scrollIntoView({ block: "nearest" });
            }, 0);
            return nextIndex;
          });
        } else if (e.key === "Escape") {
            setIsOpen(false);
            setFocusedIndex(-1);
          }
};

  return (
    <>
    <div ref={containerRef} className={Style.select__container}>
    <div className="flex starstyle">
    {label && (
            <label className={Style.label} >
              {label2}
              {/* {required && "*"} */}
            </label>
          )}
          </div>
    </div>
    <div className="dropdown">
      <div className="">
        <div className="">
          <input
            ref={inputRef}
            disabled={disabled}
            type="text"
            className={Style.input}
            value={getDisplayValue()}
            name="searchTerm"
            placeholder={placeholder}
            onChange={(e) => {
              setQuery(e.target.value);
              handleChange(null);
              // setCaculationData({...caculationData,calculatedEmi: 0 })
            }}
            onClick={toggle}
            onKeyDown={handleKeyDown}
            aria-haspopup="listbox"
            aria-expanded={isOpen}
            aria-controls={`${id}-listbox`}
            aria-activedescendant={
              isOpen && focusedIndex >= 0 ? `${id}-option-${focusedIndex}` : undefined
            }
          />
        </div>
        {/* <div className={`arrow ${isOpen ? "open" : ""}`}></div> */}
      </div>
       
      <div className={`options ${isOpen ? "open" : ""}`}
          role="listbox"
          id={`${id}-listbox`}
       >        
        {filter(options)?.map((option, index) => {
          return (
            <div
            disabled={disabled}
            ref={el => (optionRefs.current[index] = el)}
            role="option"
            tabIndex={-1}
            id={`${id}-option-${index}`}
            aria-selected={index === focusedIndex}
              onClick={() => selectOption(option)}
              className={`option ${
                option[label] === selectedVal ? "selected" : ""
              } ${index === focusedIndex ? "focused" : ""}`}
              key={`${id}-${index}`}
            >
              {option[label]}
            </div>
          );
        })}
      </div>
    </div> 
    </>
  );
};

export default SearchableDropdown;
